import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ManufacturingService { 

    constructor(private http: HttpClient) { }

    getmanufacturingService() {
        return this.http.get<any[]>(`${environment.apiUrl}get_manufacturing`);
    }    	    
}
